import moment from 'moment';
import { Item } from 'shared-types';
import { useTranslations } from '@lang';
import { golfPlayerCount } from '@features/golf/basketLine';
import { BasketDrawerTextWrapper, BasketItemText, Listing } from '../BasketDrawer.styles';

export const GolfListing = ({ golf }: { golf: Item[] }) => {
  const { t } = useTranslations();

  return (
    <Listing>
      {(golf ?? []).map((item) => {
        const players = golfPlayerCount(item);

        return (
          <div key={item.id}>
            <BasketDrawerTextWrapper>
              {moment(item?.checkIn).format('ddd, D MMM')} - {moment(item?.checkIn).format('HH:mm')}
            </BasketDrawerTextWrapper>
            <BasketDrawerTextWrapper marginBottom="10px">
              <BasketItemText>{item?.bookable?.name}</BasketItemText>
              {players > 0 && (
                <BasketItemText>{t('golf.playerCount', { count: players })}</BasketItemText>
              )}
            </BasketDrawerTextWrapper>
          </div>
        );
      })}
    </Listing>
  );
};
